import React, { ChangeEvent } from 'react';
import { Trans } from 'react-i18next';
import { Checkbox, Grid, Link, Typography } from '@material-ui/core';
import { TableCellProps } from 'react-virtualized';

import { GroupAvatar, Numeric } from 'components';
import { generateLink } from 'Links';

interface IOptions {
  className: string;
  checkedIds: string[];
  isAllChecked: boolean;
  onAllChecked: (event: ChangeEvent<HTMLInputElement>) => void;
  onChecked: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Columns = (options: IOptions) => {
  const { className, checkedIds, isAllChecked, onAllChecked, onChecked } = options;

  return [
    {
      dataKey: 'id',
      width: 60,
      className,
      muiHeaderCellProps: { padding: 'checkbox' },
      muiCellProps: { padding: 'checkbox' },
      headerContentRenderer: () => <Checkbox checked={isAllChecked} onChange={onAllChecked} />,
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Checkbox name={cellData} checked={checkedIds.includes(cellData)} onChange={onChecked} />
      ),
    },
    {
      dataKey: 'title',
      width: 300,
      className,
      label: <Trans i18nKey="common:name" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ rowData }: TableCellProps) => {
        return (
          <Grid container alignItems="center" wrap="nowrap" spacing={2}>
            <Grid item>
              <GroupAvatar size={50} link group={rowData} />
            </Grid>
            <Grid item style={{ overflow: 'hidden' }}>
              <Link
                title={rowData.title}
                component={generateLink(`/group/${rowData.id}`)}
                variant="subtitle2"
                noWrap>
                {rowData.title}
              </Link>
            </Grid>
          </Grid>
        );
      },
    },
    {
      dataKey: 'department_title',
      width: 100,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:department" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap title={cellData}>
          {cellData}
        </Typography>
      ),
    },
    {
      dataKey: 'location_title',
      width: 100,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:location" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap title={cellData}>
          {cellData}
        </Typography>
      ),
    },
    {
      dataKey: 'follower_count',
      width: 100,
      flexGrow: 1,
      className,
      label: <Trans i18nKey="common:member_plural" />,
      muiHeaderCellProps: { padding: 'none' },
      muiCellProps: { padding: 'none' },
      cellContentRenderer: ({ cellData }: TableCellProps) => (
        <Typography noWrap>
          <Numeric value={cellData} />
        </Typography>
      ),
    },
  ];
};

export default Columns;
